import { setPageTitle, useStores } from '@trivie/core'
import { Header, iconArrowBack } from '@trivie/ui-mobile'
import { color } from '@trivie/ui-web/theme'
import { observer } from 'mobx-react-lite'
import React, { useEffect, useRef, useState } from 'react'
import { ActivityIndicator, TextStyle, ViewStyle } from 'react-native'
import { useHistory, useLocation } from 'react-router-dom'
import { MediaPlayer } from '@trivie/ui-web/components/media-player/media-player'
import { Text } from '@trivie/ui-web/components/text'

const useQuery = () => {
  const { search } = useLocation()
  return React.useMemo(() => new URLSearchParams(search), [search])
}

export const SourceDetailScreen = observer(() => {
  const { libraryStore, gameStore, resourceStore, userStore, pathStore, uiStore } = useStores()
  const { getSourceDetails, resourceDetails } = resourceStore
  const { user, getBranding, enterpriseTier } = userStore

  const [loading, setLoading] = useState(true)

  const query = useQuery()
  const history = useHistory()

  const params = {
    topic_id: Number(query.get('topic_id')) || null,
    quiz_id: Number(query.get('quiz_id')) || null,
    assignment_id: Number(query.get('assignment_id')) || null,
    path_id: Number(query.get('path_id')) || null,
    content_user_id: Number(query.get('content_user_id')) || null,
    source_id: Number(query.get('source_id')) || null,
  }

  const playerRef = useRef() as any

  const loadData = () => {
    if (user) {
      getSourceDetails(params.source_id).then(() => {
        setLoading(false)
      })
    }
  }

  useEffect(() => {
    setPageTitle(`Resources - ${process.env.REACT_APP_SITE_TITLE}`)
    loadData()
  }, [])

  return (
    <div style={ROOT}>
      {loading ? (
        <div style={LOADER_CONTAINER}>
          <ActivityIndicator style={LOADER} size="small" />
        </div>
      ) : (
        <>
          <Header
            leftIcon={iconArrowBack}
            onLeftPress={history.goBack}
            center
            style={HEADER}
            titleStyle={HEADER_TITLE}
            headerTextStyle={{ paddingHorizontal: 8 }}
            headerText={resourceDetails?.title}
          />
          {resourceDetails?.isVideo || resourceDetails?.isAudio ? (
            <MediaPlayer
              variant={resourceDetails?.isVideo ? 'video' : 'audio'}
              ref={playerRef}
              url={resourceDetails?.filename_or_url}
            />
          ) : null}
        </>
      )}
    </div>
  )
})

/**
 * Styling
 */
const ROOT: React.CSSProperties = { height: '100%', maxWidth: 1000 }
const LOADER_CONTAINER: React.CSSProperties = {
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
}
const LOADER: ViewStyle = {
  flex: 1,
  alignSelf: 'center',
  position: 'relative',
  height: window.innerHeight / 2,
  bottom: 100,
}
const HEADER_TITLE: TextStyle = { fontSize: 24, color: color.black }
const HEADER: ViewStyle = { maxWidth: 800, marginBottom: 20 }
